import React from 'react'
import classNames from 'classnames'
import { Paper, Typography } from '@mui/material'
import { conditionTimeTypes } from '@app/lib/Scenes/conditionTimeTypes'
import {
  SELECT_CONDITION_TYPE,
  SELECT_TIME_CONDITION_STATE_DATE,
  SELECT_TIME_CONDITION_STATE_DAY,
  SELECT_TIME_CONDITION_STATE_TIME,
  SELECT_TIME_CONDITION_STATE_WHEN,
} from '@app/constants/routes'
import Wrapper from '@app/components/Common/Wrapper/Wrapper'
import CardBlock from '@app/components/Common/iOS/CardBlockIOS/CardBlock'
import NavBar from '@app/components/Common/iOS/NavBarIOS/NavBar'
import PropTypes from '@app/components/PropTypes'

class SelectTimeConditionType extends React.Component {
  onBackClick = () => {
    const {
      navigate,
    } = this.props
    navigate(SELECT_CONDITION_TYPE)
  }

  selectConditionTypeValue=(type) => {
    const {
      navigate,
    } = this.props
    const typeValue = type.type
    switch (typeValue) {
    case 'when':
      navigate(SELECT_TIME_CONDITION_STATE_WHEN)
      break
    case 'time':
      navigate(SELECT_TIME_CONDITION_STATE_TIME)
      break
    case 'day':
      navigate(SELECT_TIME_CONDITION_STATE_DAY)
      break
    case 'date':
      navigate(SELECT_TIME_CONDITION_STATE_DATE)
      break
    default:
      throw new Error('condition type unsupported')
    }
  }

  render() {
    const {
      classes,
      isMobile,
    } = this.props
    return (
      <Paper className={classNames(
        classes.wrapper,
        (navigator.userAgent.includes('WebView') || navigator.userAgent.includes('wv'))
        && classes.webView,
      )}
      >
        <NavBar
          title="create_scene"
          withButton={false}
          isMobile={isMobile}
          backClick={() => {
            this.onBackClick()
          }}
        />
        <Wrapper className={classes.titleWrapper}>
          <Typography className={classes.title}>{I18n.t('scene_web.select_time_type')}</Typography>
        </Wrapper>
        <Wrapper className={classes.main}>
          {
            conditionTimeTypes.map((type) => (
              <CardBlock
                key={type.title}
                title={I18n.t(`scene_web.${type.title}`)}
                position={type.position}
                buttonName={I18n.t(`scene_web.${type.buttonName}`)}
                isCardDisabled={type.isCardDisabled}
                isButtonDisabled={type.isButtonDisabled}
                onClick={() => {
                  this.selectConditionTypeValue(type)
                }}
                isMobile={isMobile}
              />
            ))
          }
        </Wrapper>
      </Paper>
    )
  }
}

SelectTimeConditionType.propTypes = {
  classes: PropTypes.object.isRequired,
  navigate: PropTypes.func.isRequired,
  isMobile: PropTypes.bool.isRequired,
}

SelectTimeConditionType.displayName = 'SelectTimeConditionTypeIOS'

export default SelectTimeConditionType
